import { ImagePreview } from '../../images/ImagePreview';
import { useContext, useState } from 'react';
import LegoAdminPageContext from '../../../pages/legoAdminPageContext';
import useAsyncEffect from '../../common/react-hooks/useAsyncEffect';
import TirePressureLegoPreview from './TirePressureLegoPreview';
import { IconButton } from '../../common/IconButton';
import { SwitchInput } from '../../common/SwitchInput';
import AIModelSelector from '../../../pages/cerokm/components/AIModelSelector';

const sampleRes = {
  "message": "{\n  \"pressuresByTire\": [\n    {\n      \"tires\": [\"185/65R15 88H\"],\n      \"pressures\": [\n        {\n          \"wheels\": \"front\",\n          \"pressure\": {\n            \"kpa\": 240,\n            \"psi\": 35\n          },\n          \"condition\": \"loadNormal\"\n        },\n        {\n          \"wheels\": \"rear\",\n          \"pressure\": {\n            \"kpa\": 240,\n            \"psi\": 35\n          },\n          \"condition\": \"loadNormal\"\n        }\n      ]\n    },\n    {\n      \"tires\": [\"T115/70R15 90M\"],\n      \"pressures\": [\n        {\n          \"wheels\": \"spare\",\n          \"pressure\": {\n            \"kpa\": 420,\n            \"psi\": 60\n          }\n        }\n      ]\n    }\n  ],\n  \"labelId\": \"LSGEN5307PD040874 1GA291 6918\"\n}",
  "prompt_tokens": 1267,
  "completion_tokens": 208,
  "total_tokens": 1475,
  "elapsedMs": 8201,
  "costEstimate": 0.0001,
  "modelName": "gpt-4.1"
};

export async function parseTirePressureContribution({ contribution, cropCorners, model, page }) {
  let imgUrl = contribution.data?.images?.[0]?.url;

  let query = {
    imageUrl: imgUrl,
    // imageUrl: getImageThumbnailMedium(imgUrl),
    context: contribution.vehicleContext,
    cropCorners,
    model,
  };

  let response = await page.service(`services/ai/read-tire-pressure-label`).find({ query: query });

  if(response.message) {
    try {
      if(response.message.startsWith('<json>')) {
        console.log('Cleaning <json>...</json> from response');
        response.message = response.message.replace('<json>', '').replace('</json>', '').trim();
      }

      response.data = JSON.parse(response.message);
      return response;
    } catch(e) {
      throw new Error("Error parsing response: "+e.message);
    }
  }
}

export default function ParseTirePressureModal({contribution, onClose}) {
  const [res, setRes] = useState();
  const [parsing, setParsing] = useState();
  const [resId, setResId] = useState();
  const [error, setError] = useState();
  const [model, setModel] = useState('gemini-flash-latest');

  const {page} = useContext(LegoAdminPageContext);

  let imgUrl = contribution.data?.images?.[0]?.url;


  let parseImage = async () => {
    try {
      setParsing(true);
      let res = await parseTirePressureContribution({ contribution, model, page});
      console.log(res);
      setRes(res);
      setResId(new Date().valueOf());
      setError(null);
    } catch(e) {
      setError("ERROR: "+e.message);
    } finally {
      setParsing(false);
    }
  };

  useAsyncEffect(parseImage, [contribution._id, model]);

  let content =  <h6>{parsing ? `Parsing with ${model}...`: 'Done'}</h6>;
  if(res) {
    content = <>
      <div className={'d-flex align-items-center'}>
          <IconButton icon={'photo_filter'} disabled={parsing} title="Reparse" onClick={parseImage}>Reparse</IconButton>
          <AIModelSelector value={model} onChange={setModel} />
      </div>
      <div className={'h6'}>
        [{(res.elapsedMs / 1000).toFixed(1)}s,
         <span className={'text-info'}>&nbsp;{res.total_tokens} tokens,</span>
         <span className={'text-danger'}>${res.costEstimate.toFixed(3)}</span>]                    
        <span className={'ml-4'}>
          {parsing ? ` Parsing with ${model}...` : null }
        </span>
      </div>

      <div>
        Label: <span className={'badge badge-primary'}>{res.data.labelId}</span>
      </div>
      <TirePressureLegoPreview data={res.data}/>
      <hr/>
      <pre className={'small mt-4 p-1 bg-light text-secondary'} style={{maxHeight: '400px'}}>{res.message}</pre>
    </>
  }

  return <div className={'row no-gutters'} style={{minWidth: '50vw'}}>
    <div className={'col-6'}>
      <ImagePreview fluidContain zoom={true} url={imgUrl}/>
    </div>
    <div className={'col-6 pl-3'}>
      {error ? <div className={'alert alert-danger m-1'}>{error}</div> : null}
      {content}
    </div>
  </div>
}

